module.exports = __webpack_public_path__ + "static/img/m_service.e548d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/m_service.png
// module id = PE7S
// module chunks = 1